/**
 * @file Adds common headers to every request, for example authentication headers and client tokens.
 * @author Arun Mahadevan
 *
 *
 */
import { apiToken } from "../config";

/**
 * Returns the common headers while authenticated
 *
 *
 * @returns {object} the common headers
 */
export const commonAuthenticatedHeaders = () => {
  return {
    Authorization: "Bearer " + sessionStorage.getItem("bearerToken"),
    tokenType: sessionStorage.getItem("ad") ? "ad" : "rem",
    clientIdentificationToken: apiToken,
    clientName: "WEB_DASHBOARD"
  };
};
/**
 * Returns the common headers while logged out
 *
 *
 * @returns {object} the common headers
 */
export const commonUnauthenticatedHeaders = () => {
  return { clientIdentificationToken: apiToken, clientName: "WEB_DASHBOARD" };
};

export const commonUnauthenticatedABDMHeaders = () => {
  return {
    "REQUEST-ID": crypto.randomUUID(),
    TIMESTAMP: new Date().toISOString(),
    "X-CM-ID": "abdm"
  };
};

export const commonAuthenticatedABDMHeaders = () => {
  return {
    "REQUEST-ID": crypto.randomUUID(),
    TIMESTAMP: new Date().toISOString(),
    Authorization: "Bearer " + sessionStorage.getItem("abdmToken")
  };
};
